/* aur-lib.js — biblioteca de seções aur-* (galeria, acordeão, carrinho AJAX, variante, sticky, countdown, reveal, carrossel, FAQ) */
(function () {
  if (window.__aurLib) return;
  window.__aurLib = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function all(scope, sel) { return [].slice.call(scope.querySelectorAll(sel)); }
  function within(scope, sel) {
    var list = all(scope, sel);
    if (scope.matches && scope.matches(sel)) list.unshift(scope);
    return list;
  }
  function once(el, key) {
    if (el['__aur' + key]) return false;
    el['__aur' + key] = true;
    return true;
  }

  /* ---------- Galeria ---------- */
  function initGallery(scope) {
    within(scope, '[data-aur-gallery]').forEach(function (g) {
      if (!once(g, 'Gallery')) return;
      var main = g.querySelector('[data-aur-main]');
      var thumbs = all(g, '[data-aur-thumb]');
      var strip = g.querySelector('[data-aur-thumbs]');
      var cur = 0;
      function show(i) {
        if (!thumbs.length || !main) return;
        cur = (i + thumbs.length) % thumbs.length;
        var t = thumbs[cur];
        main.src = t.dataset.src; main.srcset = t.dataset.srcset; main.alt = t.dataset.alt || '';
        thumbs.forEach(function (x, k) { x.classList.toggle('is-active', k === cur); });
        if (strip) strip.scrollTo({ left: t.offsetLeft - strip.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var p = g.querySelector('[data-aur-prev]'), n = g.querySelector('[data-aur-next]');
      if (p) p.addEventListener('click', function () { show(cur - 1); });
      if (n) n.addEventListener('click', function () { show(cur + 1); });
      var tp = g.querySelector('[data-aur-tprev]'), tn = g.querySelector('[data-aur-tnext]');
      function navState() {
        if (!strip) return;
        if (tp) tp.hidden = strip.scrollLeft < 4;
        if (tn) tn.hidden = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4;
      }
      if (strip) {
        strip.addEventListener('scroll', function () { requestAnimationFrame(navState); }, { passive: true });
        if (tp) tp.addEventListener('click', function () { strip.scrollBy({ left: -strip.clientWidth * 0.8, behavior: 'smooth' }); });
        if (tn) tn.addEventListener('click', function () { strip.scrollBy({ left: strip.clientWidth * 0.8, behavior: 'smooth' }); });
        navState();
      }
      var mt = g.querySelector('[data-aur-mtrack]');
      var dots = all(g, '[data-aur-mdots] span');
      if (mt && dots.length) {
        mt.addEventListener('scroll', function () {
          requestAnimationFrame(function () {
            var i = Math.round(mt.scrollLeft / mt.clientWidth);
            dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
          });
        }, { passive: true });
      }
    });
  }

  /* ---------- Acordeão (um aberto por vez dentro do hero) ---------- */
  function initAccordion(scope) {
    within(scope, '.aur-hero__acc').forEach(function (acc) {
      if (!once(acc, 'Acc')) return;
      var items = all(acc, '.aur-hero__acc-item');
      items.forEach(function (item) {
        var h = item.querySelector('.aur-hero__acc-header');
        if (!h) return;
        h.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          items.forEach(function (x) {
            x.classList.remove('is-open');
            var hh = x.querySelector('.aur-hero__acc-header');
            if (hh) hh.setAttribute('aria-expanded', 'false');
          });
          if (!open) { item.classList.add('is-open'); h.setAttribute('aria-expanded', 'true'); }
        });
      });
    });
  }

  /* ---------- Carrinho: AJAX + cart drawer do Dawn (renderContents) + brinde ---------- */
  var giftAdded = false;
  function addToCart(form, btn) {
    var fd = new FormData(form);
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) }] };
    var gift = form.querySelector('[data-aur-gift]');
    if (gift && gift.value && !giftAdded) body.items.push({ id: +gift.value, quantity: 1 });
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    if (btn) btn.setAttribute('aria-busy', 'true');
    /* Depois do add.js aceito, uma falha ao redesenhar o drawer não pode reenviar o
       formulário (o produto entraria duas vezes): vai para o carrinho. */
    var added = false;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && res.j.description);
        added = true;
        if (body.items.length > 1) giftAdded = true;
        if (drawer && typeof drawer.renderContents === 'function' && res.j.sections) {
          res.j.id = res.j.items && res.j.items[0] ? res.j.items[0].key : res.j.id;
          drawer.renderContents(res.j);
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () {
        if (added) window.location.href = root + 'cart';
        else form.submit();
      })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }
  function initForms(scope) {
    within(scope, 'form[data-aur-form]').forEach(function (form) {
      if (!once(form, 'Form')) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(form, form.querySelector('[data-aur-atc]'));
      });
    });
  }

  /* ---------- Seletor de variante do hero: preço e preço comparativo ---------- */
  function initVariants(scope) {
    within(scope, '[data-aur-variant]').forEach(function (sel) {
      if (!once(sel, 'Variant')) return;
      /* Hero e barra sticky ficam no mesmo wrapper de seção da Shopify. */
      var box = sel.closest('.shopify-section') || sel.closest('.aur-hero') || document;
      function sync() {
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        var price = opt.getAttribute('data-price') || '';
        var compare = opt.getAttribute('data-compare') || '';
        all(box, '[data-aur-price]').forEach(function (el) { el.textContent = price; });
        all(box, '[data-aur-compare]').forEach(function (el) {
          el.textContent = compare;
          el.hidden = !compare;
        });
        /* Botão de compra segue a disponibilidade da variante escolhida. */
        all(box, '[data-aur-atc]').forEach(function (btn) {
          btn.disabled = opt.disabled;
          var text = btn.querySelector('[data-aur-atc-text]');
          var label = btn.getAttribute(opt.disabled ? 'data-label-soldout' : 'data-label-buy');
          if (text && label) text.textContent = label;
        });
      }
      sel.addEventListener('change', sync);
      /* O navegador pode restaurar a escolha ao voltar para a página. */
      sync();
    });
  }

  /* ---------- Barra sticky ---------- */
  function initSticky(scope) {
    within(scope, '[data-aur-sticky]').forEach(function (sticky) {
      if (!once(sticky, 'Sticky')) return;
      var atc = document.querySelector('[data-aur-atc]');
      if (!atc || !('IntersectionObserver' in window)) return;
      var sb = sticky.querySelector('[data-aur-sticky-btn]');
      var seen = false;
      function setVisible(v) {
        sticky.classList.toggle('is-visible', v);
        sticky.setAttribute('aria-hidden', v ? 'false' : 'true');
        if (sb) sb.tabIndex = v ? 0 : -1;
      }
      new IntersectionObserver(function (en) {
        var e = en[0];
        if (e.isIntersecting) { seen = true; setVisible(false); }
        else if (seen || e.boundingClientRect.top < 0) setVisible(true);
      }).observe(atc);
      if (sb) sb.addEventListener('click', function () {
        var f = atc.closest('form');
        if (f) addToCart(f, sb);
      });
    });
  }

  /* ---------- Rolagem suave até a oferta ---------- */
  function initScroll(scope) {
    within(scope, '[data-aur-scroll]').forEach(function (a) {
      if (!once(a, 'Scroll')) return;
      a.addEventListener('click', function (e) {
        var t = document.querySelector('#aur-offer') || document.querySelector('#aur-hero');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* countdown:start */
  /* Countdown até uma data final real. A barra sobe para o topo do <body>, fora do editor. */
  function initCountdown(scope) {
    within(scope, '[data-aur-countdown]').forEach(function (bar) {
      if (!once(bar, 'Countdown')) return;
      var designMode = window.Shopify && window.Shopify.designMode;
      if (!designMode && document.body && bar.parentElement !== document.body) {
        document.body.insertBefore(bar, document.body.firstChild);
      }
      var clock = bar.querySelector('[data-aur-clock]');
      var end = Date.parse(bar.getAttribute('data-aur-end') || '');
      if (!clock || !end || isNaN(end) || end <= Date.now()) return;
      var D = bar.querySelector('[data-aur-d]'), H = bar.querySelector('[data-aur-h]');
      var M = bar.querySelector('[data-aur-m]'), S = bar.querySelector('[data-aur-s]');
      function p(n) { return n < 10 ? '0' + n : '' + n; }
      var iv;
      function tick() {
        var left = end - Date.now();
        if (left <= 0) { clock.hidden = true; clearInterval(iv); return; }
        var s = Math.floor(left / 1000);
        D.textContent = p(Math.floor(s / 86400));
        H.textContent = p(Math.floor((s % 86400) / 3600));
        M.textContent = p(Math.floor((s % 3600) / 60));
        S.textContent = p(s % 60);
      }
      clock.hidden = false;
      iv = setInterval(tick, 1000);
      tick();
    });
  }
  /* countdown:end */

  /* ---------- Reveal ao rolar ---------- */
  var pend = [];
  var ticking = false;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function check() {
    ticking = false;
    var lim = window.innerHeight * 0.94;
    pend = pend.filter(function (e) {
      if (e.getBoundingClientRect().top < lim) { e.classList.add('is-in'); return false; }
      return true;
    });
    if (!pend.length) { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
  function initReveal(scope) {
    var fresh = within(scope, '[data-aur-reveal]').filter(function (e) { return once(e, 'Reveal'); });
    if (reduce || (window.Shopify && window.Shopify.designMode)) {
      fresh.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    if (!fresh.length) return;
    var wasEmpty = !pend.length;
    pend = pend.concat(fresh);
    if (wasEmpty) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }
    check();
  }

  /* ---------- Carrossel de cartões e FAQ (um aberto por vez) ---------- */
  function initSales(scope) {
    within(scope, '.aur-sec').forEach(function (r) {
      if (!once(r, 'Sales')) return;
      var t = r.querySelector('[data-aur-track]');
      if (t) {
        var cards = t.querySelectorAll('[data-aur-card]');
        var dots = all(r, '[data-aur-dot]');
        var step = function () { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : t.clientWidth; };
        var upd = function () {
          var i = Math.round(t.scrollLeft / step());
          dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        };
        t.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
        var pv = r.querySelector('[data-aur-cprev]'), nx = r.querySelector('[data-aur-cnext]');
        if (pv) pv.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (nx) nx.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: 'smooth' }); });
        dots.forEach(function (d) {
          d.addEventListener('click', function () {
            t.scrollTo({ left: step() * +d.getAttribute('data-aur-dot'), behavior: 'smooth' });
          });
        });
      }
      all(r, 'details.aur-sec__q').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) all(r, 'details.aur-sec__q[open]').forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  function init(scope) {
    initCountdown(scope);
    initGallery(scope);
    initAccordion(scope);
    initForms(scope);
    initVariants(scope);
    initSticky(scope);
    initScroll(scope);
    initReveal(scope);
    initSales(scope);
  }

  ready(function () { init(document); });
  /* Editor de temas: seção recarregada ou adicionada. */
  document.addEventListener('shopify:section:load', function (e) { if (e.target) init(e.target); });
})();
